import { z } from 'zod';

export type CompanyResultType = z.infer<typeof companyLazySchema>;
export type CompanyDetailType = z.infer<typeof companyDetailSchema>;
export type CompanyRelationType = z.infer<typeof companyRelationSchema>;

export const companyRelationSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string().optional(),
});

export const companyLazySchema = companyRelationSchema.extend({
  city: z.string(),
});

export const companyDetailSchema = z.object({
  id: z.number(),
  name: z.string(),
  shortName: z.string().optional(),
  vatCode: z.string(),
  description: z.array(z.string()),
  contact: z.object({
    streetAddress: z.string(),
    postalCode: z.string(),
    postOffice: z.string(),
    email: z.string(),
    phone: z.string(),
    coordinates: z
      .object({
        latitude: z.number(),
        longitude: z.number(),
      })
      .optional(),
  }),
  picture: z.string().optional(),
  pricing: z.string().optional(),
  internalOfficeIds: z.array(z.number()).optional(), // Not used anywhere
});
